module.exports = __webpack_public_path__ + "static/media/x-icon.5fda4e88.svg";